<template>
    <div class="app-main gyslist-page">
		<el-row type="flex" class="app-main-header" align="middle">
			<!-- 页面title -->
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{ $route.meta.title }}</span>
				</div>
			</el-col>
			<!-- 批量操作 -->
			<el-col :span="18" class="app-main-header-btns">
				<!-- <el-button size="small" type="primary" @click="handleAdd" v-hasPermi="['gys:supplierInfo:add']">新增 </el-button> -->
				<el-button size="small" type="primary" :disabled="ids.length==0" v-if="checkRole('gys_audit') || checkRole('cgy_role')" @click="handleBatchDel">批量删除 </el-button>
				<!-- <el-dropdown style="margin-left:10px;">
					<el-button size="small" plain>更多操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item>
							<el-upload class="upload-demo" :action="baseURL+'/app/supplierInfo/import'"
									:show-file-list="false" accept=".xls,.xlsx,application/msword"
									:on-success="handleAvatarExcel" :before-upload="beforeExcel"
									:headers="{'Authentication':token()}">
							<el-button size="mini" type="text" v-hasPermi="['gys:supplierInfo:import']"
										title="请按导出数据格式导入数据">导入Excel
							</el-button>
							</el-upload>
						</el-dropdown-item>
						<el-dropdown-item>
							<el-button size="mini" type="text" @click="handleExport" v-hasPermi="['gys:supplierInfo:export']">导出Excel </el-button>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown> -->
			</el-col>
		</el-row>
		<el-row class="mg-b5">
			<el-card class="box-card">
				<!-- 顶部搜索 -->
				<div slot="header" class="clearfix">
					<el-form :inline="true" class="demo-form-inline" size='mini'>
						<el-form-item class="my-form-item">
							<el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
											v-model="quertInfo.searchTime" start-placeholder="开始日期" value-format="yyyy-MM-dd"
											style="width: 200px" end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<!-- <el-form-item class="my-form-item">
							<el-select size="mini" clearable v-model="quertInfo.objMap.status" style="width:100px"
									placeholder="选择状态">
								<el-option label="启用" value="0"></el-option>
								<el-option label="禁用" value="1"></el-option>
							</el-select>
						</el-form-item> -->
						<el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
									style="width: 160px" prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<el-form-item>
							<treeselect
								style="width:150px"

								v-model="quertInfo.objMap.supplierClassificationId"
								:show-count="true"
								:options="optionMenus"
								:normalizer="normalizer"
								placeholder="选择分类"
							/>
							<!-- <el-cascader :props="parentClassProps" v-model="quertInfo.objMap.classId" style="width:150px"></el-cascader> -->
						</el-form-item>
						<el-form-item>
							<el-select v-model="quertInfo.objMap.gysType" clearable style="width: 100%" size="mini" placeholder="请选择供应商状态">
								<el-option label="合格供应" :value="1"></el-option>
								<el-option label="潜在供应商" :value="2"></el-option>
								<el-option label="不合格供应商" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" @click="onSearch"
									v-hasPermi="['gys:supplierInfo:query']">查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<!-- 表格 -->
				<el-table :data="tableData" border size="mini" ref="tableRef" :header-cell-style="headerCellStyle" :height="PAGESIZE.h-220" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="40" v-if="checkRole('gys_audit') || checkRole('cgy_role')" align="left"> </el-table-column>
					<el-table-column prop="name" label="企业名称" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<el-button type="text" @click="showInfo(scope.row)">{{scope.row.name}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="tyShXxCode" label="统一社会信息代码" :show-overflow-tooltip="true" width="120"> </el-table-column>
					<el-table-column prop="qyTyoe" label="企业类型" :show-overflow-tooltip="true" width="120"> </el-table-column>
					<el-table-column prop="supplierClassificationName" label="分类" :show-overflow-tooltip="true"> </el-table-column>
					<el-table-column prop="gysTypeName" label="状态" :show-overflow-tooltip="true"> </el-table-column>
					<el-table-column prop="taxpayerSign" label="纳税人标识" :show-overflow-tooltip="true" width="120"> </el-table-column>
					<el-table-column prop="manageArea" label="经营范围" :show-overflow-tooltip="true"> </el-table-column>
					<el-table-column prop="zyClass" label="主营品类" :show-overflow-tooltip="true"> </el-table-column>
						<el-table-column prop="jyXz" label="经营性质" :show-overflow-tooltip="true" width="120"> </el-table-column>
					<el-table-column prop="hyType" label="行业类型" :show-overflow-tooltip="true" width="120"> </el-table-column>
					<el-table-column prop="shFwScope" label="送货服务范围" :show-overflow-tooltip="true" width="120"> </el-table-column>
					<el-table-column prop="gsGw" label="公司官网" :show-overflow-tooltip="true" width="120"> </el-table-column>
					<el-table-column prop="gysdjName" label="供应商等级" :show-overflow-tooltip="true" width="80"> </el-table-column>
					<el-table-column prop="ifhmdName" label="是否黑名单" :show-overflow-tooltip="true" width="80"> </el-table-column>
					<!-- <el-table-column type="selection" width="40" align="left"> </el-table-column>
					<el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true" width="120">
						<template slot-scope="scope">
							<el-link type="primary" @click="showDrawer(scope.row)">
							{{ scope.row.createTime }}
							</el-link>
						</template>
					</el-table-column>
					<el-table-column label="创建人" width="80" prop="createUser">
					</el-table-column>
					<el-table-column prop="name" label="企业名称" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="rzRegion" label="认证地区" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="tyShXxCode" label="统一社会信息代码" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="englishName" label="英文名称" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="qyShort" label="企业简称" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="orgJgCode" label="组织机构代码" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="dbsCode" label="邓白氏编码" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="qyTyoe" label="企业类型" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="taxpayerSign" label="纳税人标识" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="country" label="注册国家/地区" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="address" label="详细地址" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="legalPerson" label="法定代表人" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="zcCapital" label="注册资本" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="zcCurrency" label="注册资本货币种类(万)" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="foundDate" label="建立日期" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="manageArea" label="经营范围" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column label="附件" width="95">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.yyZzSrc==undefined" type="info">无附件 </el-tag>
						<el-link v-else :underline="false" :href="baseURL+scope.row.yyZzSrc" target="_blank">
							<el-tag type="success">查看附件</el-tag>
						</el-link>
					</template>
					</el-table-column>
					<el-table-column prop="zySf" label="主要身份" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="jyXz" label="经营性质" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="hyType" label="行业类型" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="zyClass" label="主营品类" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="shFwScope" label="送货服务范围" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="gsGw" label="公司官网" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="gsLogoSrc" label="公司Logo" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="gsDetail" label="公司简介(以上是业务信息)" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="invoiceHead" label="发票头" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="swDjh" label="税务登记号" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="khhName" label="开户行" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="khhNumber" label="开户行账号" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="swDjDz" label="税务登记地址" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="swDjDh" label="税务登记电话" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="sprEmail" label="收票人邮箱" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="sprDh" label="收票人电话(以上是开票信息)" :show-overflow-tooltip="true" width="120">
					</el-table-column>
					<el-table-column prop="qyXz" label="企业性质" :show-overflow-tooltip="true" width="120">
					</el-table-column> -->
					<!-- <el-table-column prop="status" label="状态0启用1停用" :formatter="formatStatus"></el-table-column> -->
					<!-- <el-table-column label="操作" width="120" align="left" fixed="right"> -->
					<el-table-column label="操作" width="120" align="left">
						<template slot-scope="scope">
							<!-- <el-button type="text" size="small" @click="handleEdit(scope.row)"
									v-hasPermi="['gys:supplierInfo:edit']">修改
							</el-button>
							<el-button type="text" size="small" @click="handleDel(scope.row.id)"
									v-hasPermi="['gys:supplierInfo:del']">删除
							</el-button> -->
							 <el-button type="text" size="small" @click="handleEdit2(scope.row)">设置供应商等级</el-button>
							 <el-button type="text" size="small" @click="handleEdit3(scope.row)">设置黑名单</el-button>
							<el-button type="text" size="small" @click="showInfo(scope.row)" >查看详情 </el-button>
							<el-button type="text" size="small" @click="editInfo(scope.row)" >修改</el-button>
							<!-- <el-button type="text" size="small" @click="showAuditInfo(scope.row)" >审核详情 </el-button> -->
							<!-- <el-link :underline="false" :href="`/gys/showgysinfo/${scope.row.id}?hide=1`" size="mini" target='_blank' type="primary">审核详情</el-link> -->
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<el-row type="flex" justify="end" class="mg-t5">
					<pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
								:limit.sync="quertInfo.limit" :total="count">
					</pagination>
				</el-row>
			</el-card>
		</el-row>
		<!-- 表单 -->
		<EditDialog ref="EditDialogRef" @callback="EditDialogCallback" />
		<EditDialog2 ref="EditDialogRef2" @callback="EditDialogCallback2" />
		<EditDialog3 ref="EditDialogRef3" @callback="EditDialogCallback3" />
		<!-- 详情 -->
		<DrawerInfo ref="DrawerInfoRef" @callback="DrawerInfoCallback"/>
		<!-- 详情 -->
		<ShowGysInfo ref="ShowGysInfoRef" @callback="ShowGysInfoCallback"/>
    </div>
</template>

<script>
import {
	supplierInfoList,
	addSupplierInfo,
	editSupplierInfo,
	delSupplierInfo,
	batchDelSupplierInfo,
	exportSupplierInfo,
} from '@/api/gys/supplierInfo.js'
import { queryByParentId } from '@/api/gysmng/index.js'
import EditDialog from './EditDialog'
import EditDialog2 from './EditDialog2'
import EditDialog3 from './EditDialog3'
import DrawerInfo from './DrawerInfo'
import Treeselect from '@riophae/vue-treeselect'
import ShowGysInfo from '../../../components/ShowGysInfo'
export default {
	name: "SupplierInfo",
	computed: {
		PAGESIZE:function(){
			return this.$store.getters['app/sizeInfo'];
		},
	},
	components:{
		EditDialog,DrawerInfo,ShowGysInfo,Treeselect,EditDialog2,EditDialog3
	},
	data() {
		return {
			optionMenus: [],
			tableData: [],
			ids: [],
			loadingInstance: undefined,
			count: 0,
			quertInfo: {
				page: 1, //当前页码
				limit: 20, //当前每页显示的数量
				searchTime: [],
				objMap: {
					status:2,
					supplierClassificationId:undefined,
					gysType:undefined
				}
			},
			parentClassProps:{
				value:'id',
				label:'name'
			}
		};
	},
	created() {
		this.getList();
		this.getTreeselect();
	},
	methods: {
		normalizer(node) {
            //删除 数据的子集
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.id,
                //将name转换成必填的label键
                label: node.name,
                children: node.children
            };
		},
		async getMenuData(callback){
            let _this = this;
            const { data: res } = await queryByParentId({});
            if (res.code == 0) {
                let nodes = res.data || [];
                // nodes.forEach((no)=>{
                //     no['name'] = '一级分类';
                // })
                if(callback){
                    callback(nodes)
                }
            }
        },
		getTreeselect() {
            let _this = this;
            _this.optionMenus = [];
            this.getMenuData((data)=>{
                _this.optionMenus.push(data[0]);
                _this.optionMenus=data[0].children||[];
            })
        },
		ShowGysInfoCallback(obj){

		},
		showInfo(row){
			// this.$refs.ShowGysInfoRef.show('audit',row)
			//  this.$router.push({path: '/gys/showgysinfo/'+row.id});
			 this.$router.push({path: '/gys/gysInfoLast/'+row.id});
		},
		editInfo(row){
			this.$router.push({path: '/gysRegister/gysRegister/'+row.id});
		},
		showAuditInfo(row){
			// this.$router.push({path: '/gys/showauditinfo/'+row.id});
			// window.open(`/gys/showgysinfo/${row.id}?hide=1`)
			window.open(`/gys/gysInfoLast/${row.id}`)
		},
		onPagination: function (val) {
			this.quertInfo.page = val.page;
			this.quertInfo.limit = val.limit;
			this.getList();
		},
		async getList() {
			let _this = this;
			const { data: res } = await supplierInfoList(_this.quertInfo)
			if (res.code == 0) {
				_this.tableData = res.data;
				_this.count = res.count;
				this.$nextTick(function(){
					if(_this.$refs.tenderTable){
                        _this.$refs.tenderTable.doLayout();
                    }
				})
			}
		},
		onSearch: function () {
			//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
			this.quertInfo.page = 1;
			this.getList();
		},
		showDrawer: function(row){
			this.$refs.DrawerInfoRef.form = row;
			this.$refs.DrawerInfoRef.drawer = true;
		},
		DrawerInfoCallback: function(obj){
			if(obj.type == 1){
				this.handleEdit(obj.form)
			}
		},
		handleAdd: function () {
			this.$refs.EditDialogRef.reset();
			this.$refs.EditDialogRef.title = "新增";
			this.$refs.EditDialogRef.openDialog = true;
		},
		handleEdit: function (row) {
			this.$refs.EditDialogRef.reset();
			this.$refs.EditDialogRef.title = "修改";
			this.$refs.EditDialogRef.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
			this.$refs.EditDialogRef.openDialog = true;
		},
		handleEdit2: function (row) {
            this.$refs.EditDialogRef2.reset();
            this.$refs.EditDialogRef2.title = "修改";
            this.$refs.EditDialogRef2.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
            this.$refs.EditDialogRef2.openDialog = true;
        },
        handleEdit3: function (row) {
            this.$refs.EditDialogRef3.reset();
            this.$refs.EditDialogRef3.title = "修改";
            this.$refs.EditDialogRef3.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
            this.$refs.EditDialogRef3.openDialog = true;
        },
		EditDialogCallback(obj){
			if(obj.type == 1 || obj.type == 2){
				this.getList()
			}
		},
		handleSelectionChange(val) {
			this.ids = [];
			for (let item of val) {
				this.ids.push(item.id);
			}
		},
		handleBatchDel: function () {
			//批量删除
			let _this = this;
			if (_this.ids.length <= 0) {
				_this.$fail("请勾选要删除的行数据");
				return false;
			}
			_this.confirm({
				text: '确认删除吗',
				tip: '警告',
				type: '',
				fn: function (param) {
					batchDelSupplierInfo(param).then(response => {
						if (response.data.code === 0) {
							_this.$success(response.data.msg);
							_this.getList();
						} else {
							_this.$fail(response.data.msg);
						}
					});
				},
				data: {
					ids: _this.ids
				} //参数对象 主要回调函数用
			});
		},

		handleDel: function (id) {
			let _this = this;
			_this.confirm({
				text: '确认删除吗',
				tip: '警告',
				type: '',
				fn: function (param) {
					delSupplierInfo(param).then(response => {
						if (response.data.code === 0) {
							_this.$success(response.data.msg);
							_this.getList();
						} else {
							_this.$fail(response.data.msg);
						}
					});
				},
				data: {
					id: id
				} //参数对象 主要回调函数用
			});
		},

		handleExport: function () {
			let _this = this;
			_this.confirm({
				text: '导出当前页，还是全部导出',
				but1: '全部导出',
				but2: '当前页',
				type: '',
				fn: function () {
					let param = JSON.parse(JSON.stringify(_this.quertInfo));
					param.page = 0;
					exportSupplierInfo(param).then(response => {
						if (response.data.code === 0) {
							_this.download(response.data.data);
						} else {
							_this.$fail(response.data.msg);
						}
					});
				},
				cancel: function () {
					exportSupplierInfo(_this.quertInfo).then(response => {
						if (response.data.code === 0) {
							_this.download(response.data.data);
						} else {
							_this.$fail(response.data.msg);
						}
					});
				},
			});
		},

		handleAvatarExcel(res, file) {
			if (res.code == 0) {
				this.getList();
			}
			this.loadingInstance.close();
			this.$success(res.msg);
		},

		beforeExcel(file) {
			// 判断文件后缀
			let type = file.name.substring(file.name.lastIndexOf('.') + 1);
			if (!(type == "xls" || type == "xlsx")) {
				this.$fail('请导入Excel文件');
				return false;
			}

			const isLt2M = file.size / 1024 / 1024 <= 1;
			if (!isLt2M) {
				this.$fail('导入Excel不能超过 1MB!');
				return false;
			}
			this.loadingInstance = this.Loading({
				text: '导入中请等待...'
			});
		},
		formatStatus: function (row) {
			return row.status == 0 ? '启用' : '禁用';
		},
	}
};
</script>
<style>
.gyslist-page .vue-treeselect__control{
	height: 28px;
}
.gyslist-page .vue-treeselect__placeholder{
	line-height: 28px;
}
/** * 全屏弹框 不滚动 */
/* .el-dialog__wrapper {
  overflow: hidden;
} */
/*头+padding10 +加尾+padding10 + 2px 边框*/
/* .newDialog ::v-deep .el-dialog__body {
  overflow: auto;
  height: calc(100vh - 160px);
} */
</style>
